export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      contentsSnapshots: [
        {
          contentsSnapshotId: 2,
          contentsSnapshotUuid: 'snapshot002',
          snapshotName: '見守り01',
          snapshotTag: "mimamori",
          // versionName: "1.3.6",
          releaseNote: "リリースノート",
        },
        {
          contentsSnapshotId: 1,
          contentsSnapshotUuid: 'snapshot001',
          snapshotName: '警戒01',
          snapshotTag: "keikai",
          // versionName: "1.0.1",
          releaseNote: "リリースノート",
        }
      ]
    }
  }
}